import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PlayerTotalPointsItem {
    player_id?: number;
    total_points_v3?: number;
    race_count?: number;
    average_points_v3?: number;
    wins?: number;
    top5?: number;
    name_psn?: string;
    name_gt7?: string;
    car_id?: number;
    car_name?: string;
}

@Injectable()
export class RaceDaysTableService {
    private apiRaceTotalPointsOverviewUrl = `${environment.apiBaseUrl}/api/racesGetTotalPointsOverviewForSeasonV3.php`;

    constructor(private http: HttpClient) {}

    getRaceDaysTable(season: string): Observable<PlayerTotalPointsItem[]> {
        const params = new HttpParams().set('season', season);
        return this.http.get<PlayerTotalPointsItem[]>(this.apiRaceTotalPointsOverviewUrl, { params });
    }
}